import { toast } from 'react-toastify';
import s from '../allservices.jsx';
import { getClientId, getClientSecret,buildClientHeader } from "../../utils/clientAuth.js";

const getCardDetailService = (actionCallback, cardRefNo, toggler) => {
    let token = "Token " + localStorage.getItem('token')
    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    let traceId = getClientId();
    fetch(plink + s.card_detail_service + "/" + cardRefNo , {
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token,
            'X-Trace-Id': traceId,
            'X-Client-APP':buildClientHeader(),

        })
    })
        .then(res => {
            if (res.status === 200 ) {
                if(localStorage.getItem('cardSearchToast')=== 'first'){
                    toast.success(res.headers.get('message'), {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 2000,
                        newestOnTop: true,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                    localStorage.setItem('cardSearchToast','second')
                }
                
                res.json().then(json => actionCallback(json, "success"))
            } 
            else if(res.status === 204){
                actionCallback(res.headers.get('message'), "no-data")
                toggler(res.headers.get('message'))
            }
            else if(res.status === 401){
                actionCallback("401", "sessionout")
            }
            else {
                toast.error(res.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
                actionCallback("no body", "error")
            }
        })
}

export default getCardDetailService;


// WEBPACK FOOTER //
// ./src/services/components/card_detail_service.jsx